import React, {createContext} from 'react'

export const QueryContext = createContext();

export const QueryProvider = ( {searchProps = {}, children} ) =>
    <QueryContext.Provider value={{...searchProps}}>
        {children}
    </QueryContext.Provider>;

